export default __webpack_public_path__ + "static/media/logo-sm-light.77faa26b.png";